import { render, staticRenderFns } from "./threeDimensionalPersonality.vue?vue&type=template&id=28cdcfa4&scoped=true"
import script from "./threeDimensionalPersonality.vue?vue&type=script&lang=js"
export * from "./threeDimensionalPersonality.vue?vue&type=script&lang=js"
import style0 from "./threeDimensionalPersonality.vue?vue&type=style&index=0&id=28cdcfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cdcfa4",
  null
  
)

export default component.exports